// /adoption — TenantAdoptionDashboard. tenant_admin only.
// V1 demo = invite-team empty state.

import { Button } from '@gc-coach/design-system';
import { EmptyState } from '../shell/index.js';
import { useI18n } from '../i18n/index.js';

export function AdoptionPage() {
  const { t } = useI18n();
  return (
    <EmptyState
      eyebrow={t('shell.adoption.eyebrow')}
      headline={t('shell.adoption.headline')}
      body={t('shell.adoption.body')}
      primary={
        <Button kind="primary" disabled>
          {t('shell.adoption.primaryCta')}
        </Button>
      }
    />
  );
}
